var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"works"},[_c('left-menu',{attrs:{"current":_vm.$route.meta.name || _vm.$route.name}}),_c('div',{staticClass:"main",class:{'no-white-background': _vm.$route.meta.noWhiteBackground}},[_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }